import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import useDidMountEffect from 'assets/js/useDidMountEffect';

export default function Pagination(props) {
  const [offset, setOffset] = useState(0);
  const [isPage, setIsPage] = useState(false);
  const [isBtn, setIsBtn] = useState(0);

  useEffect(() => {
    if (props.offset) {
      setOffset(props.offset);
    }
  }, [props.offset]);

  useEffect(() => {
    if (props.data.offset === 0) {
      setIsBtn(0);
    } else if (props.data.offset !== 0 && props.data.offset !== props.data.pageNum - 1) {
      setIsBtn(1);
    } else if (props.data.offset === props.data.pageNum - 1) {
      setIsBtn(2);
    }
  }, [props.data.offset]);

  useDidMountEffect(() => {
    if (isPage) {
      props.search(offset);
    }
  }, [offset]);

  const pageChange = offset => {
    if (props.data.offset !== offset) {
      setIsPage(true);
      setOffset(offset);
    }
  };

  return (
    <PageBox>
      {props.data.offset !== 0 && (
        <>
          <button onClick={() => pageChange(0)}>
            <img src='https://ust-kr.s3.ap-northeast-2.amazonaws.com/assets/support/first_arrow.svg' alt='first'/>
          </button>
          <button onClick={() => pageChange(props.data.offset - 1)}>
            <img src='https://ust-kr.s3.ap-northeast-2.amazonaws.com/assets/support/prev_arrow.svg' alt='next'/>
          </button>
        </>
      )}
      <ul className='page-list'>
        {new Array(5).fill(0).map((_, i) => i + props.data.offset - isBtn).map((item, idx) => {
          if (item === props.data.offset) {
            return <li key={idx}>
              <button className='selected' onClick={() => pageChange(item)}>{item + 1}</button>
            </li>;
          } else if (item >= 0 && item < props.data.pageNum) {
            return <li key={idx}>
              <button onClick={() => pageChange(item)}>{item + 1}</button>
            </li>;
          }
        })}
      </ul>
      {props.data.offset !== props.data.pageNum - 1 && (
        <>
          <button onClick={() => pageChange(props.data.offset + 1)}>
            <img src='https://ust-kr.s3.ap-northeast-2.amazonaws.com/assets/support/next_arrow.svg' alt='next'/>
          </button>
          <button onClick={() => pageChange(props.data.pageNum - 1)}>
            <img src='https://ust-kr.s3.ap-northeast-2.amazonaws.com/assets/support/last_arrow.svg' alt='last'/>
          </button>
        </>
      )}
    </PageBox>
  )
}

const PageBox = styled.div`
  position: relative;
  margin-top: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0 16px;

  .page-list {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0 12px;

    li button {
      font-weight: 400;
      font-size: 14px;
      color: #000000;

      &.selected {
        font-weight: 700;
      }
    }
  }
`;